export default __webpack_public_path__ + "static/media/ppt_background.7a097755.png";